module.exports = __webpack_public_path__ + "img/location-hero-bg.7f4976f3.png";